var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvidersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499774 9.35733C0.490271 8.91069 0.571081 8.46672 0.737358 8.05207C0.903635 7.63742 1.15195 7.26063 1.46741 6.94429C1.78288 6.62796 2.15898 6.3786 2.57317 6.21118C2.98736 6.04376 3.4311 5.96173 3.87777 5.97C4.23042 5.16817 4.80686 4.48507 5.53798 4.00263C6.2691 3.52018 7.12387 3.25886 7.99977 3.25C9.18538 3.27232 10.3175 3.74753 11.1638 4.57812C12.0101 5.4087 12.5065 6.53169 12.5511 7.71667C12.9147 7.64535 13.2896 7.65661 13.6482 7.74962C14.0068 7.84263 14.3399 8.01502 14.623 8.25404C14.906 8.49307 15.1318 8.79263 15.2835 9.1306C15.4353 9.46857 15.5092 9.83631 15.4998 10.2067C15.4998 12.792 12.8911 12.7513 12.8911 12.7513H3.43444C2.61718 12.637 1.86919 12.2299 1.32945 11.6057C0.789699 10.9815 0.494885 10.1825 0.499774 9.35733V9.35733Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.75L9.5 10.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.75L12.5 10.25",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvidersIcon);
export default __webpack_public_path__ + "static/media/Providers_icon.195d4a29.svg";
export { ForwardRef as ReactComponent };